import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AutoComplete, Checkbox, Chip, IconButton, MenuItem, SelectField } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import AlertIcon from 'material-ui/svg-icons/alert/warning';

import api from 'services';
import { updateTcOrder } from 'actions/tc/orders';

const styles = {
    add: {
        display: 'flex',
        justifyContent: 'center',
    },
    chips: {
        margin: '8px 8px 0 0',
    },
};

const getDefaultIncExc = () => ({
    cargoId: null,
    cargoName: null,
    dangerous: false,
    bulk: 'dry-bulk',
    cargoType: {
        name: null,
    },
});
class Cargo extends React.PureComponent {
    state = {
        cargoNames: [],
        includedCargo: getDefaultIncExc(),
        excludedCargo: getDefaultIncExc(),
    };

    dAutocomplete = _.debounce((searchText) => {
        api.getCargoNamesAutocomplete(searchText)
            .then((response) => {
                const cargoNames = response.data.data.map(cargoName => ({
                    name: cargoName.name,
                    item: cargoName,
                }));

                this.setState({
                    cargoNames,
                });
            })
            .catch(() => null);
    }, 1000);

    onChangeAutoCompleteCargoName = (value, type) => {
        this.setState({
            [`${type}Cargo`]: {
                ...this.state[`${type}Cargo`],
                cargoName: value,
                cargoId: null,
            },
        }, () => {
            this.dAutocomplete(value);
        });
    }

    onChooseAutoCompleteCargoName = (selected, type) => {
        if (!selected) {
            return;
        }

        const { item: { _id: cargoId, name: cargoName, parent } } = selected;

        this.setState({
            [`${type}Cargo`]: {
                ...this.state[`${type}Cargo`],
                cargoId,
                cargoName,
                cargoType: {
                    details: selected.item.details,
                    ...selected.item.parent.red,
                },
            },
            cargoNames: [],
        });
    }

    addCargo = (type) => {
        const {
            cargoId, cargoName, cargoType, dangerous, bulk, 
        } = this.state[`${type}Cargo`];

        const _tcOrder = _.cloneDeep(this.props.tcOrder);

        const alreadyExists = _tcOrder.cargo[type].find(i => i.cargoId === cargoId && i.cargoType._id === cargoType._id && i.dangerous === dangerous && i.bulk === bulk);

        if (!alreadyExists) {
            _tcOrder.cargo[type].push({
                cargoId, cargoName, cargoType, dangerous, bulk, 
            });
    
            this.props.updateTcOrder(this.props.numberOrderTable, _tcOrder);
        }

        this.setState({
            [`${type}Cargo`]: getDefaultIncExc(),
        });
    }

    deleteCargo = (type, index) => {
        const cargoIncExc = _.cloneDeep(this.props.tcOrder.cargo[type]);

        cargoIncExc.splice(index, 1);

        this.props.updateTcOrder(this.props.numberOrderTable, { 
            ...this.props.tcOrder, 
            cargo: {
                ...this.props.tcOrder.cargo,
                [type]: cargoIncExc,
            },
        });
    }

    changeField = (type, field, value) => {
        this.setState({
            [`${type}Cargo`]: {
                ...this.state[`${type}Cargo`], 
                [field]: value,
            },
        });
    }

    render() {
        const { cargoNames } = this.state;
        const { cargoTypes = [], tcOrder: { cargo } } = this.props;
        return (
            <div> 
                {
                    ['included', 'excluded'].map((typeIncExc, index) => (
                        <div key={typeIncExc}>
                            <div className='row' key={`typeIncExc_${index}`}>
                                <div className='col-xs-3'>
                                    <AutoComplete
                                        name='cargoName'
                                        textFieldStyle={{ fontSize: '13px' }}
                                        hintText={`Cargo name (${typeIncExc})`}
                                        searchText={this.state[`${typeIncExc}Cargo`].cargoName || ''}
                                        dataSource={cargoNames}
                                        dataSourceConfig={{ text: 'name', value: 'item' }}
                                        onUpdateInput={value => this.onChangeAutoCompleteCargoName(value, typeIncExc)}
                                        onNewRequest={value => this.onChooseAutoCompleteCargoName(value, typeIncExc)}
                                        filter={AutoComplete.noFilter}
                                        listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                        menuStyle={{ width: '500px' }}
                                        popoverProps={{
                                            canAutoPosition: true,
                                            style: { width: 'auto' },
                                        }}
                                        fullWidth
                                    />

                                </div>
                                <div className='col-xs-3'>
                                    <SelectField 
                                        value={this.state[`${typeIncExc}Cargo`].cargoType._id || ''}
                                        onChange={
                                            (_e, _i, value) => this.changeField(
                                                typeIncExc, 
                                                'cargoType', { 
                                                    _id: value, 
                                                    name: cargoTypes.find(ct => ct._id === value).name, 
                                                },
                                            )
                                        }
                                        name='Cargo Type'
                                        disabled={!!this.state[`${typeIncExc}Cargo`].cargoId}
                                        floatingLabelText='Cargo Type'
                                        floatingLabelStyle={{ fontSize: '13px' }}
                                        style={{ marginTop: '-22px', fontSize: '13px' }}
                                        fullWidth
                                        autoWidth
                                    >
                                        {
                                            cargoTypes.map(cargoType => (
                                                <MenuItem 
                                                    key={`cargoType_${cargoType._id}`} 
                                                    value={cargoType._id} 
                                                    primaryText={cargoType.name} 
                                                />
                                            ))
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-2'>
                                    <SelectField 
                                        value={this.state[`${typeIncExc}Cargo`].bulk || ''}
                                        style={{ marginTop: '12px', fontSize: '13px' }}
                                        onChange={(_e, _i, value) => this.changeField(typeIncExc, 'bulk', value)}
                                        fullWidth
                                        autoWidth
                                    >
                                        {
                                            ['Dry-bulk', 'Wet-bulk', 'Break-bulk'].map(anotherCargoType => (
                                                <MenuItem
                                                    key={`anotherCargoType_${anotherCargoType}`} 
                                                    value={anotherCargoType.toLowerCase()} 
                                                    primaryText={anotherCargoType} 
                                                />
                                            ))
                                        }
                                    </SelectField>
                                </div>
                                <div className='col-xs-2'>
                                    <Checkbox
                                        label="Dangerous"
                                        iconStyle={{ marginRight: '5px' }}
                                        checked={this.state[`${typeIncExc}Cargo`].dangerous}
                                        onCheck={() => this.changeField(typeIncExc, 'dangerous', !this.state[`${typeIncExc}Cargo`].dangerous)}
                                    />
                                </div>
                                <div className='col-xs-2' style={styles.add}>
                                    <IconButton>
                                        <ContentAddIcon
                                            onClick={() => {
                                                this.addCargo(typeIncExc);
                                            }}
                                            color='green'
                                        />
                                    </IconButton>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-xs-12' style={{ display: 'flex', flexFlow: 'wrap' }}>
                                    {
                                        cargo && cargo[typeIncExc] && cargo[typeIncExc].map((cgo, index) => {
                                            const backgroundColor = typeIncExc === 'excluded' ? '#e6e6e6' : '#d6edbd';
                                            return (
                                                <Chip
                                                    key={`cgo_${index}`}
                                                    onRequestDelete={() => this.deleteCargo(typeIncExc, index)}
                                                    style={{ ...styles.chips, backgroundColor, whiteSpace: 'initial' }}
                                                >
                                                    {
                                                        cgo.dangerous && 
                                                            <AlertIcon style={{ margin: '0 4px -6px 0' }} color='red' />
                                                    }
                                                    {`${cgo.cargoName || 'Any'} (${cgo.cargoType.name ? `${cgo.cargoType.name}, ` : ''}${cgo.bulk})`}
                                                </Chip>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default connect(
    ({ tcOrders, cargoTypes }) => ({
        // tcOrders,
        cargoTypes,
    }),
    dispatch => bindActionCreators({
        updateTcOrder,
    }, dispatch),
)(Cargo);



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/TC/content/Cargo.jsx